import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=ea158dfa&"
import script from "./Page8.vue?vue&type=script&lang=js&"
export * from "./Page8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports